import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessServer } = protos;

/**
 * Create a server.
 *
 * @param {String} name The server's name to display in the UI.
 * @param {String} color The color to display for the server.
 * @returns {Object} A redux TockApi action.
 */
export function create(name: string, color: string): ApiAction {
  const request = BusinessServer.fromObject({
    name,
    color,
    excludeFromRotation: false,
  });
  return {
    TockApi: {
      postProto: '/business/server',
      type: AppConstants.BUSINESS_SERVER_ADD,
      request,
    },
  };
}

/**
 * Update a server.
 *
 * @param {number} id The id of the server to update.
 * @param {String} name The new name for the server.
 * @param {String} color The new color for the server.
 * @param {boolean} excludeFromRotation The new excludeFromRotation setting for the server.
 * @returns {Object} A redux TockApi action.
 */
export function update(
  id: number,
  name: string,
  color: string,
  excludeFromRotation: boolean
): ApiAction {
  const request = BusinessServer.fromObject({
    id,
    name,
    color,
    excludeFromRotation,
  });
  return {
    TockApi: {
      putProto: `/business/server`,
      request,
      type: AppConstants.BUSINESS_SERVER_UPDATE,
    },
  };
}

/**
 * Remove a server.
 *
 * @param {number} id the ID of the server to remove.
 * @returns {Object} A redux TockApi action.
 */
export function remove(id: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/business/server/${id}`,
      type: AppConstants.BUSINESS_SERVER_REMOVE,
    },
  };
}

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/server',
      type: AppConstants.BUSINESS_SERVER_FETCH,
    },
  };
}
